<!-- Modal Overlay / Backdrop -->
@if (visible) {
<div
  class="modal-overlay"
  [class.with-backdrop]="backdrop"
  (click)="onBackdropClick($event)"
  [style.zIndex]="zIndex"
  tabindex="-1"
  aria-hidden="true"
></div>

<!-- Modal Dialog -->
<div
  #modalDialog
  class="modal-dialog"
  [attr.data-tone]="tone"
  [attr.data-emphasis]="emphasis"
  [attr.data-surface]="surface"
  [attr.role]="ariaDescribedBy ? 'dialog' : 'alertdialog'"
  aria-modal="true"
  [attr.aria-label]="ariaLabel || heading"
  [attr.aria-labelledby]="ariaLabelledBy || (heading ? 'modal-title' : null)"
  [attr.aria-describedby]="ariaDescribedBy"
  [style.zIndex]="zIndex ? zIndex + 1 : null"
  tabindex="0"
>
  <!-- Modal Header -->
  <div class="modal-header">
    @if (heading) {
    <h2 id="modal-title" class="modal-title">{{ heading }}</h2>
    }
    <ng-content select="[modal-title], [modalTitle]"></ng-content>

    <!-- Close Button -->
    @if (closable) {
    <button
      #closeButton
      type="button"
      class="modal-close-btn"
      (click)="onCloseClick()"
      aria-label="Close modal"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    }
  </div>

  <!-- Modal Content -->
  <div class="modal-body" [attr.id]="ariaDescribedBy || 'modal-desc'">
    <ng-content></ng-content>
  </div>

  <!-- Modal Footer (optional) -->
  <div class="modal-footer">
    <ng-content select="[modal-footer], [modalFooter]"></ng-content>
  </div>
</div>
}
